import React from 'react';
import Upload from './Upload';

function App() {
  return (
    <div className="App">
      <Upload />
    </div>
  );
}

export default App;
